<picture>
    <source srcset="{{this.url}}img/sistemas2/{{systemId}}-saldo.{{size}}.webp" type="image/webp" [title]="title">
    <source srcset="{{this.url}}img/sistemas2/{{systemId}}-saldo.{{size}}.png" type="image/png" [title]="title">
    <img src="{{this.url}}img/sistemas2/{{systemId}}-saldo.{{size}}.png" width="{{width}}" height="{{height}}" [alt]="alt" [title]="title">
</picture>
